module.exports = __webpack_public_path__ + "assets/img/inbank-logo.9671f058.png";